import getApp from './application';

getApp().then(({ app }) => {
  app.$mount('#app');
});
